import { render, staticRenderFns } from "./driverVerification.vue?vue&type=template&id=37928030&"
import script from "./driverVerification.vue?vue&type=script&lang=js&"
export * from "./driverVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports